import { RetailerLocation } from '@andromeda/shopping-cart-data-access-store';
import { Offer } from '@andromeda/polaris-data-access-products';
import IProductSlot from '../../models/ProductSlot';

const buildUrl = (selectedRetailer: RetailerLocation, selectedProducts: IProductSlot<Offer>[], subId1: string, subId2: string, smToken: string): string => {
    if (!selectedRetailer.fulfillmentStoreId) {
        const walmartUri = new URL('http://www.walmart.com/');
        return walmartUri.toString();
        // eslint-disable-next-line no-else-return
    } else {
        const walmartUri = new URL(`https://goto.walmart.com/c/2375857/1207219/9383?subId1=${subId1}&subId2=${subId2}&subId3=${smToken}&veh=aff&sourceid=imp_000011112222333344`);
        const itemIds: string[] = [];
        let items = '';
        selectedProducts.forEach(p => itemIds.push(p.id));
        itemIds.filter(id => id.length).forEach((id: string, i: number) => {
            if (i === 0) {
                items += `${id}_1`;
            } else {
                items += `,${id}_1`;
            }
        });
        const affiliateUri = `https://affil.walmart.com/cart/0/2?storeId=${selectedRetailer.fulfillmentStoreId}&items=${items}`;
        walmartUri.searchParams.append('u', affiliateUri);
        return walmartUri.toString();
    }
};

const handleClick = (selectedRetailer: RetailerLocation, selectedProducts: IProductSlot<Offer>[], subId1: string, subId2: string, smToken: string): void => {
    // Send one event per product because redshift can't handle large json values
    const uri = buildUrl(selectedRetailer, selectedProducts, subId1, subId2, smToken);
    window.open(uri, '_blank');
};
export default handleClick;
